import { formatDistanceToNowStrict } from "date-fns";

export function getFormattedDistanceToNow(date) {
  const options = {
    locale: {
      formatDistance: (unit, count) => {
        switch (true) {
          case unit === "xDays":
            return count === 1 ? `${count} day ago` : `${count} days ago`;

          case unit === "xHours":
            return count === 1 ? `${count} hour ago` : `${count} hours ago`;

          case unit === "xMinutes":
            return count === 1 ? `${count} minute ago` : `${count} minutes ago`;

          case unit === "xMonths":
            return count === 1 ? `${count} month ago` : `${count} months ago`;

          case unit === "xSeconds":
            return "just now";

          case unit === "xYears":
            return count === 1 ? `${count} year ago` : `${count} years ago`;

          default:
        }

        return "%d hours";
      },
    },
  };

  return formatDistanceToNowStrict(date, options);
}
